export default {
  title: 'Pagos a cuenta, gastos reembolsables y otros'
}
